import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.992 6.738a1.167 1.167 0 1 0-1.65 1.65l3.319 3.32-3.32 3.318a1.167 1.167 0 1 0 1.65 1.65l3.32-3.319 3.318 3.319a1.166 1.166 0 1 0 1.65-1.65l-3.319-3.319 3.32-3.319a1.166 1.166 0 1 0-1.65-1.65l-3.32 3.32z"
    }, null, -1)
  ])))
}
export default { render: render }